import React from 'react';
import { Box, DateTimeStandard } from '@curves/ui-base';

import { parseDate } from '@Util/moment.util';
const DateTimeDisplay = ({ date }) => {
    return (
        <React.Fragment>
            <Box>{parseDate(date, DateTimeStandard.DisplayDateBySlash)}</Box>
            <Box className={'font-color-3'}>{parseDate(date, DateTimeStandard.DisplayTime)}</Box>
        </React.Fragment>
    );
};
export default DateTimeDisplay;
